import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
export const usePrePayList = (id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("usePreviewOrdercontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `usePrePayList-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `usePrePayList-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `usePrePayList-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const getPrePayList = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.prepayList(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value.load = null;
      } else {
        error.value.load = new Error(res.message);
        result.value = null;
      }
    } catch (err) {
      error.value.load = err;
      result.value = null;
    } finally {
      loading.value = false;
    }
  };

  return {
    getPrePayList,
    prepaylist: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
